import { RecordType } from '@petconsole/pure-base';
import { vetApiEntity } from '@petconsole/pure-fe-api';
import { VetRecord } from '@petconsole/pure-shared';
import { sliceHookTypes } from '../../../helpers';
import {
  BaseSliceOptions,
  BaseSliceTab,
  CitySearchHooks,
  OurEntityHooks,
  RatingHooks,
  RequiredCrudSliverHooks,
  RequiredSliverHooks,
  TabValueHooks,
} from '../../../types';
import BaseEntitySlice from '../../base/BaseEntitySlice';

type ApiEntityRecord = VetRecord;

const apiEntity = vetApiEntity;
const { name: sliceName, plural } = apiEntity;
const vet = sliceName;
const vets = plural;
const vetAdmin = `${sliceName}Admin`;

const Tab = { vetAdmin, vet, vets } as const;
type Tabs = { [key in keyof typeof Tab]: BaseSliceTab };
type TabHooks = { [key in keyof typeof Tab]: TabValueHooks };
const tabs: Tabs = {
  vetAdmin: { default: '' },
  vet: { default: '' },
  vets: { default: '' },
};

const options: BaseSliceOptions<ApiEntityRecord> = {
  ...apiEntity,
  sortProperty: 'practiceName',
  hasCitySliver: true,
  hasNewestSliver: true,
  hasCitySearch: true,
  hasDefaultProperties: true,
  hasRating: true,
  tabs,
};
const { hooks, reducer } = new BaseEntitySlice<ApiEntityRecord>({ options });
const { crudHooks, sliverHooks, propertyHooks, citySearchHooks, ratingHooks, tabHooks } = sliceHookTypes;

export interface OurVetHooks<T extends RecordType = ApiEntityRecord> extends OurEntityHooks<T> {
  vetHooks: RequiredCrudSliverHooks;
  cityVetHooks: RequiredSliverHooks;
  newestVetHooks: RequiredSliverHooks;
  propertyHooks: RecordType;
  citySearchHooks: CitySearchHooks;
  ratingHooks: RatingHooks;
  tabHooks: TabHooks;
}

export const ourVetHooks: OurVetHooks = {
  entity: apiEntity,
  vetHooks: crudHooks(apiEntity, hooks) as RequiredCrudSliverHooks,
  cityVetHooks: sliverHooks(apiEntity, 'City', hooks) as RequiredSliverHooks,
  newestVetHooks: sliverHooks(apiEntity, 'Newest', hooks) as RequiredSliverHooks,
  citySearchHooks: citySearchHooks(apiEntity, hooks),
  propertyHooks: propertyHooks(apiEntity, hooks),
  ratingHooks: ratingHooks(apiEntity, hooks),
  tabHooks: <TabHooks>tabHooks(Object.keys(Tab), hooks),
};

export default reducer;
